import { Box, Button, Checkbox, Grid, Slider, TextField, Typography } from "@mui/material";
import RootComponents from "../../components/common/RootComponents"
import styles from './SearchCandidate.module.css';
import { customTextColor } from "../../utils/const";
import MatchesResultPublicResume from "../../components/containers/MatchesResultPublicResume";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MatchesResultInternalResume from "../../components/containers/MatchesResultInternalResume";

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const CST = [
    'North Dakota ND',
    'Minnesota MN',
    'South Dakota SD',
    'Wisconsin WI',
    'Nebraska NE',
    'Iowa IA',
    'Kansas KS',
    'Missouri MO',
    'Illinois IL',
    'Oklahoma OK',
    'Arkansas AR',
    'Kentucky KY',
    'Tennessee TN',
    'Texas TX',
    'Louisiana LA',
    'Mississippi MS',
    'Alabama AL'
]

const EST = [
    'Michigan MI',
    ' Indiana IN',
    'Ohio OH',
    'Pennsylvania PA',
    'New York NY',
    'Vermont VT',
    'Maine ME',
    'New Hampshire NH',
    'Massachusetts MA',
    'Rhode Island RI',
    'Connecticut CT',
    'New Jersey NJ',
    'Delaware DE',
    'Maryland MD',
    'District of Columbia DC',
    'Kentucky KY',
    'West Virginia WV',
    'Virginia VA',
    'Tennessee TN',
    'North Carolina NC',
    'South Carolina SC',
    'Georgia GA',
    'Florida FL',
]

const visa = [
    'USC/US Citizen/Citizen',
    'GC/Green Card',
    'GC EAD/EAD GC',
    'H1B',
    'H4EAD',
    'L1 L2EAD',
    'B1',
    'TN',
    'E3',
    'OPT EAD',
    'CPD EAD',
    'Other'
]

const JobSearchResult = () => {
    const [typeResult, setTypeResult] = useState('public')

    const [expanded, setExpanded] = useState(false);
    const [expandedDiagnosis, setExpandedDiagnosis] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangeDiagnosis = (panel) => (event, isExpanded) => {
        setExpandedDiagnosis(isExpanded ? panel : false);
    };

    return (
        // <RootComponents>
            <Box className={styles.search_candidate_stucture}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={2.5} lg={2.5}>

                        <Accordion className="accordion_body" expanded={expanded === 'subpanel3'} onChange={handleChange('subpanel3')} style={{ border: '1px solid #f2f2f2', margin: '10px' }} >
                            <AccordionSummary
                                expandIcon={expanded === 'subpanel3' ? <RemoveIcon /> : <AddIcon />}
                                aria-controls="panel1-content"
                                className={styles.accordion_text}
                            >
                                Mode of Hiring
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Contract</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Contract to Hire</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Full Time</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>W2</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>1099</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                                        />
                                    </Box>

                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="accordion_body" expanded={expanded === 'subpanel1'} onChange={handleChange('subpanel1')} style={{ border: '1px solid #f2f2f2', margin: '10px' }}>
                            <AccordionSummary
                                expandIcon={expanded === 'subpanel1' ? <RemoveIcon /> : <AddIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                className={styles.accordion_text}
                            >
                                Location
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: '0px' }}>
                                <Box>
                                    <Accordion className="accordion_body" expanded={expandedDiagnosis === 'panel10'} onChange={handleChangeDiagnosis('panel10')} style={{ border: '1px solid #f2f2f2', margin: '10px' }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2-content"
                                            id="panel2-header"
                                            className={styles.accordion_text}
                                        >
                                            PST
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ height: '10rem', overflowY: 'scroll' }}>
                                            <Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Washington WA</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span> Oregon OR</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>California CA</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Nevada NV</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>

                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', marginTop: '20px' }}>
                                                    <span>Distance</span>
                                                    <Slider defaultValue={0} aria-label="Default" valueLabelDisplay="on" />
                                                </Box>

                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion className="accordion_body" expanded={expandedDiagnosis === 'panel11'} onChange={handleChangeDiagnosis('panel11')} style={{ border: '1px solid #f2f2f2', margin: '10px' }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2-content"
                                            id="panel2-header"
                                            className={styles.accordion_text}
                                        >
                                            MST
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ height: '10rem', overflowY: 'scroll' }}>
                                            <Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Montana MT</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Idaho ID</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Wyoming WY</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Utah UT</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Colorado CO</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Arizona AZ</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>New Mexico NM</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', marginTop: '20px' }}>
                                                    <span>Distance</span>
                                                    <Slider defaultValue={0} aria-label="Default" valueLabelDisplay="on" />
                                                </Box>
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                    <Accordion className="accordion_body" expanded={expandedDiagnosis === 'panel13'} onChange={handleChangeDiagnosis('panel13')} style={{ border: '1px solid #f2f2f2', margin: '10px' }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2-content"
                                            id="panel2-header"
                                            className={styles.accordion_text}
                                        >
                                            CST
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ height: '10rem', overflowY: 'scroll' }}>
                                            <Box>
                                                {
                                                    CST.map((state) => {
                                                        return (
                                                            <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                                <span>{state}</span>
                                                                <Checkbox
                                                                    {...label}
                                                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                                />
                                                            </Box>
                                                        )
                                                    })
                                                }
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', marginTop: '20px' }}>
                                                    <span>Distance</span>
                                                    <Slider defaultValue={0} aria-label="Default" valueLabelDisplay="on" />
                                                </Box>

                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>

                                    <Accordion className="accordion_body" expanded={expandedDiagnosis === 'panel14'} onChange={handleChangeDiagnosis('panel14')} style={{ border: '1px solid #f2f2f2', margin: '10px' }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel2-content"
                                            id="panel2-header"
                                            className={styles.accordion_text}
                                        >
                                            EST
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ height: '10rem', overflowY: 'scroll', padding: '8px 7px 16px' }}>
                                            <Box>
                                                {
                                                    EST.map((state) => {
                                                        return (
                                                            <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                                <span>{state}</span>
                                                                <Checkbox
                                                                    {...label}
                                                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                                />
                                                            </Box>
                                                        )
                                                    })
                                                }
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', marginTop: '20px' }}>
                                                    <span>Distance</span>
                                                    <Slider defaultValue={0} aria-label="Default" valueLabelDisplay="on" />
                                                </Box>

                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>

                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="accordion_body" expanded={expanded === 'subpanel2'} onChange={handleChange('subpanel2')} style={{ border: '1px solid #f2f2f2', margin: '10px' }} >
                            <AccordionSummary
                                expandIcon={expanded === 'subpanel2' ? <RemoveIcon /> : <AddIcon />}
                                aria-controls="panel1-content"
                                className={styles.accordion_text}
                            >
                                Visa
                            </AccordionSummary>
                            <AccordionDetails sx={{ height: '10rem', overflowY: 'scroll', padding: '8px 7px 16px' }}>
                                <Box>
                                    {
                                        visa.map((state) => {
                                            return (
                                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>{state}</span>
                                                    <Checkbox
                                                        {...label}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                                    />
                                                </Box>
                                            )
                                        })
                                    }


                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="accordion_body" expanded={expanded === 'subpanel4'} onChange={handleChange('subpanel4')} style={{ border: '1px solid #f2f2f2', margin: '10px' }} >
                            <AccordionSummary
                                expandIcon={expanded === 'subpanel4' ? <RemoveIcon /> : <AddIcon />}
                                aria-controls="panel1-content"
                                className={styles.accordion_text}
                            >
                                Work Preference
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>On-site</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Hybrid</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Remote</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                        />
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="accordion_body" expanded={expanded === 'subpanel5'} onChange={handleChange('subpanel5')} style={{ border: '1px solid #f2f2f2', margin: '10px' }} >
                            <AccordionSummary
                                expandIcon={expanded === 'subpanel5' ? <RemoveIcon /> : <AddIcon />}
                                aria-controls="panel1-content"
                                // id="panel1-header"
                                className={styles.accordion_text}
                            >
                                Rate/Salary
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Hourly Rate</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Salaried</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                        />
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="accordion_body" expanded={expanded === 'subpanel6'} onChange={handleChange('subpanel6')} style={{ border: '1px solid #f2f2f2', margin: '10px' }} >
                            <AccordionSummary
                                expandIcon={expanded === 'subpanel6' ? <RemoveIcon /> : <AddIcon />}
                                aria-controls="panel1-content"
                                // id="panel1-header"
                                className={styles.accordion_text}
                            >
                                Resume Updated In
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', marginTop: '20px' }}>
                                    <span>Days</span>
                                    <Slider defaultValue={0} aria-label="Default" valueLabelDisplay="on" />
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        <Accordion className="accordion_body" expanded={expanded === 'subpanel7'} onChange={handleChange('subpanel7')} style={{ border: '1px solid #f2f2f2', margin: '10px' }} >
                            <AccordionSummary
                                expandIcon={expanded === 'subpanel7' ? <RemoveIcon /> : <AddIcon />}
                                aria-controls="panel1-content"
                                // id="panel1-header"
                                className={styles.accordion_text}
                            >
                                Candidate Status
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Verified Candidate</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                        />
                                    </Box>
                                    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>Verified Recruiter</span>
                                        <Checkbox
                                            {...label}
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                                        />
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>

                    <Grid item xs={12} sm={12} md={9.5} lg={9.5}>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Box className={styles.job_serach_result_heading}>
                                    <Typography sx={{ color: customTextColor }}>SEARCH RESULT</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={7} lg={7} sx={{ padding: '10px 10px 10px 0' }}>
                                <TextField
                                    label="JOB INFORMATION"
                                    variant="outlined"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5} sx={{ padding: '10px 0 10px 10px' }}>
                                <Box className={styles.choose_resume}>
                                    <Typography onClick={() => setTypeResult('public')} sx={typeResult === 'public' ? { color: 'green' } : { color: customTextColor }}>120 Results</Typography>
                                    <Typography onClick={() => setTypeResult('internal')} sx={typeResult === 'internal' ? { color: 'green' } : { color: customTextColor }}>Internal Resume</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={7} lg={7} sx={{ padding: '10px 10px 10px 0' }}>
                                <TextField
                                    label="Required Skills"
                                    multiline
                                    rows={7}
                                    sx={{ width: "100%", marginBottom: '20px' }}
                                />

                                <TextField
                                    label="Nice to Have Skills"
                                    multiline
                                    rows={5}
                                    sx={{ width: "100%" }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5} sx={{ padding: '10px 0 10px 10px' }}>
                                {
                                    typeResult === 'public' ?
                                        <>
                                            <MatchesResultPublicResume />
                                            <MatchesResultPublicResume />
                                        </>
                                        :
                                        <>
                                            <MatchesResultInternalResume />
                                            <MatchesResultInternalResume />
                                            <MatchesResultInternalResume />
                                        </>
                                }

                            </Grid>
                        </Grid>
                        <Box className={styles.job_search_result_btns}>
                            <Button sx={{ padding: '9px 45px !important' }}>Back</Button>
                            <Button>Select All</Button>
                        </Box>
                    </Grid>
                </Grid>


            </Box>
        // </RootComponents>
    )
}

export default JobSearchResult;